import CloseIcon from "@mui/icons-material/Close";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { lighten } from "@mui/material/styles";
import { styled } from "@mui/material/styles";
import { useTheme } from "@mui/material/styles";

const CustomizedComponent = styled(DialogTitle)(({ theme }) => ({
  backgroundColor: theme.palette.commonground.main,
  color: theme.palette.commonground.contrastText,
  webkitUserSelect: "none",
  userSelect: "none",
  padding: theme.spacing(1.5),
  paddingLeft: theme.spacing(2),
}));

const OmniDialogTitle = props => {
  const { children, onClose = null, ...other } = props;

  const theme = useTheme();

  return (
    <CustomizedComponent variant="h5" {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          size="large"
          sx={{
            position: "absolute",
            right: theme.spacing(0.5),
            top: theme.spacing(0.5),
            color: theme.palette.secondary.main,
            "&:hover": {
              background: lighten(theme.palette.secondary.main, 0.75),
              border: `none`,
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </CustomizedComponent>
  );
};

export default OmniDialogTitle;
